import React, { Component} from 'react';
import { connect } from 'react-redux';
import {Link, withRouter } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import $ from 'jquery';
import TopBtnNav from './TopBtnNav';
import ContactUs from './components/ContactUs';

import {MOBILE_STORES} from '../../app/common/mobile-stores.js'

class Header extends Component {

    constructor(props) {
        super(props);

        this.state =  {
            navigationBox   : false,
              screenWidth   : null,
              fileName      : null,

            buttonUpload    : true,
            buttonChange    : false,
        
            contactFormBox  : false,
            contactResultBox: false,
        
           fileNamecontainer: false,
           labelImportMsg   : '',
           isInsideApp      : props.history?.location?.pathname ? props.history?.location?.pathname.includes('/app/') : false,  
        };
    }

    componentDidUpdate(prevProps) {
        const pathname = this.props.history?.location?.pathname;
        if(this.state.isInsideApp !== pathname?.includes('/app/')) {
            this.setState({
                isInsideApp      : this.props.history?.location?.pathname ? this.props.history?.location?.pathname.includes('/app/') : false,  
              });
        }
        if(pathname?.includes('/app/')) {
            $('.menuLink').each(function () {
                $(this).removeClass('active');
            });
        }
        if(pathname?.includes('/team')){
            $('.about-us').each(function () {
                $(this).addClass('active');
            });
        } else {
            $('.about-us').each(function () {
                $(this).removeClass('active');
            });
        }
        
        if(pathname?.includes('/faq')){
            $('.faqLink').each(function () {
                $(this).addClass('active');
            });
        } else {
            $('.faqLink').each(function () {
                $(this).removeClass('active');
            });
        }
    }

    componentDidMount() {
        this.setState({
            screenWidth:  window.innerWidth
          });
        
        $('.clearState, .menuLink').on('click', function () {
        $('.menuLink').each(function () {
            $(this).removeClass('active');
        });
        });
    
        $('.menuLink').on('click', function () {
        $('body').removeClass('scroll-off');
    
        $(this).addClass('active');
        });
    
        $('.menu-toggle, .open-contact, .contact-box-button').on('click', function () {
        $('body').toggleClass('scroll-off');
        });
    
        $('.close').on('click', function () {
        $('body').removeClass('scroll-off');
          });

        window.addEventListener('resize', this.updateOnResize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateOnResize);
    }
    
    updateOnResize = () => {this.setState({ screenWidth:  window.innerWidth }); }

    
    toggleNavigationBox = () => {
        if (this.state.screenWidth < 1025) {
            this.setState({ navigationBox: !this.state.navigationBox });
        }
    }
    
    toggleContactFormBox = () => {
        this.setState({ contactFormBox: !this.state.contactFormBox });
    }

    onFileChange = (event) => {
        const files = event.target.files;

        this.setState({
            fileNamecontainer   : true,
            fileName            : files.item(0),
            buttonChange        : !this.state.buttonChange,
            buttonUpload        : !this.state.buttonUpload,
            labelImportMsg      : Array.from(files).map(f => f.name)
          });

          console.log(this.state.labelImportMsg)
    }

    fileInputClick = () => { 
        this.fileInput.current.click();
    }
    
    render() {
        return(
          <div>
            <div id="top"></div>
            <header className={"page-header " + (this.state.navigationBox ? "opened" : "closed") }>

                <div className="wrapper">
                    <div className="container-main" id="menuLinks">
                        <div className="top">
                            <div className="inner-wrapper">
                                <figure className="logo">
                                    <Link to="/" title="Nu INS" className="clearState">
                                        <img src="/img/logo-dark.png" alt="Застраховай се в движение с NuIns" onClick={ () => window.scrollTo(0,0)}></img>
                                    </Link>
                                </figure>
                                <div className="homepage-link">
                                    {!this.state.isInsideApp
                                    ? <> 
                                        <Link to="/" className="clearState">
                                            <span>Начало</span>
                                        </Link>
                                    <span className={"menu-toggle " + (this.state.navigationBox ? 'close' : 'open')} onClick={this.toggleNavigationBox}></span>
                                    </>
                                    : <>
                                        {this.props.isLoggedIn 
                                            ?
                                            <Link to="/app/profile" fragment="demo" className="menuLink profile" >
                                                <>потребител:  <b>&nbsp;{this.props.userName}</b></>
                                            </Link>
                                            : <></>
                                        } 
                                        <TopBtnNav toggleContactFormBox={this.toggleContactFormBox} />
                                    </> 
                                     }
                                </div>
                            </div>
                        </div>
                        <nav className="menu">
                            <ul>
                                {!this.state.isInsideApp 
                                ?   <li onClick={this.toggleNavigationBox} id="1" >
                                        <HashLink to="/#demo" fragment="demo" className="menuLink " >
                                            <i className="icon-app"></i>
                                            <span>Нашето приложение</span>
                                        </HashLink>
                                    </li>
                                :   <></>
                                }

                                <li onClick={this.toggleNavigationBox} id="5" >
                                    <HashLink to="/#news" fragment="news" className="menuLink" >
                                        <i className="icon-about"></i>
                                        <span>Новини</span>
                                    </HashLink>
                                </li>

                                <li onClick={this.toggleNavigationBox} id="2" >
                                    {/*
                                        <HashLink to="/#about" fragment="about" className="menuLink about-us">
                                            <i className="icon-about"></i>
                                            <span>За нас</span>
                                        </HashLink>
                                    */}
                                    <Link to="/team" className="menuLink about-us">
                                        <i className="icon-about"></i>
                                        <span>За нас</span>
                                    </Link>
                                </li>

                                <li onClick={this.toggleNavigationBox} id="3" >
                                    <Link to="/faq" className="menuLink faqLink">
                                        <i className="icon-faq"></i>
                                        <span>Често задавани въпроси</span>
                                    </Link>
                                </li>
                                <li onClick={this.toggleNavigationBox} id="4" >
                                    <Link to="/" onClick={this.toggleContactFormBox} className="menuLink open-contact">
                                        <i className="icon-contact"></i>
                                        <span>Пиши ни</span>
                                    </Link>
                                </li>
                                {this.state.isInsideApp && this.props.isLoggedIn
                                ?   <li id='5'>
                                        <Link to="/app/profile" fragment="demo" className="menuLink profile" >
                                            <i className="icon-app"></i>
                                            <span>потребител:  <b>&nbsp;{this.props.userName}</b></span>
                                        </Link>
                                    </li>
                                :<></>}
                            </ul>
                        </nav>
                        <div className="app-download">
                            <h2>Свали приложението от</h2>
                            <ul className="download-buttons show1">
                                <li>
                                    <figure className="google-play">
                                        <a href={MOBILE_STORES.playStoreUrl} title="Свали от Google Play">
                                            <img src="/img/download-google-play.png" alt="Nu INS app in Google Play" ></img>
                                        </a>
                                    </figure>
                                </li>
                                <li>
                                    <figure className="app-store">
                                        <a href={MOBILE_STORES.appStoreUrl} title="Свали от App Store">
                                            <img src="/img/download-app-store.png" alt="Nu INS app in App Store" ></img>
                                        </a>
                                    </figure>
                                </li>
                                <li>
                                    <figure className="app-gallery">
                                        <a href={MOBILE_STORES.appGalleryUrl} title="Свали от App Gallery">
                                            <img src="/img/download-huawei.png" alt="Nu INS app in App Gallery" ></img>
                                        </a>
                                    </figure>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </header>

            <div className="pusher"></div>

            <div className="contact-box-button" onClick={this.toggleContactFormBox}>
                <i className="icon icon-contact"></i>
            </div>

            <ContactUs show={this.state.contactFormBox} toggleContactFormBox={this.toggleContactFormBox} />

        </div>  
        );
    }
};

function mapStateToProps(state) {
    return { 
            userName: state.userDetails.firstNameCyrillic,
            isLoggedIn: state.auth?.loginToken,
        };
}

export default withRouter(connect(mapStateToProps)(Header));


/*
<div className={"contact-box " + (this.state.contactFormBox ? 'show-main' : 'hide')}>
<div className="header">
    <div className="wrapper">
        <figure className="logo">
            <img src="/img/logo-dark.png" alt="Nu INS logo"></img>
        </figure>
        <span className="close" onClick={this.toggleContactFormBox}></span>
    </div>
</div>
<div className="form">
    <span className="close" onClick={this.toggleContactFormBox}></span>
    <form action="" method="post" encType="multipart/form-data">
        <h2>Ние сме тук, за да отговорим на твоите въпроси</h2>
        <div className="nuins-mail">
            <i className="icon icon-mail"></i> <span>help@nuins.io</span>
        </div>
        <div className="form-group">
            <input type="email" name="email" placeholder="Твоят имейл" autoComplete="off"></input>
        </div>
        <div className="form-group">
            <input type="text" name="subject" placeholder="Тема" autoComplete="off"></input>
        </div>
        <div className="form-group">
            <textarea className="message" placeholder="Съобщение"></textarea>
        </div>
        <div className="file-upload">
            <input type="file" name="file" ref={this.fileInput} onChange={this.onFileChange}></input>
            <div className="button" style={{width: "50%"}}>
                <div className="wrapper">
                    <div className={"upload " + (this.state.buttonUpload ? 'show-main' : 'hide')} onClick={this.fileInputClick}>
                        <i className="icon icon-upload"></i>
                        <span>
                            Прикачи файл
                        </span>
                    </div>
                    <div className={"change " + (this.state.buttonChange ? 'show-main' : 'hide')} onClick={this.fileInputClick}>
                        <i className="icon icon-edit"></i>
                        <span>
                            Редактирай
                        </span>
                    </div>
                </div>
            </div>
            <div className="uploaded">
                <div className={"wrapper " + (this.state.fileNamecontainer ? 'show-main' : 'hide')} >
                    <span>{this.state.labelImportMsg}</span>
                </div>
            </div>
        </div>
        <input type="submit" value="Изпрати съобщението" name="submit" onClick={this.toggleContactResultBox}></input>
    </form>
</div>
</div> */